import Vue from 'vue'

// axios
import axios from 'axios'
const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE2NjYxOTYzNTcsImp0aSI6InRaZW1EZFExNFVlN1wvVzFPTEZleHU3UmsxUlFBSEtla1VFTEdEaXRNN1pzPSIsImlzcyI6ImFwaS5nYW5hcHAudGsiLCJuYmYiOjE2NjYxOTYzNTcsImV4cCI6MTY2NjgwMTE1Nywic2VjdXJpdHkiOnsidXNlcm5hbWUiOiJBZG1pbmlzdHJhdG9yIiwidXNlcmlkIjoiLTEiLCJwYXJlbnR1c2VyaWQiOiIiLCJ1c2VybGV2ZWxpZCI6LTF9fQ.w_WHdFT7_Wtd8ulE1Y2S76hEnJryKfDxM8d5nUHJKnta7MH30o0T_oiQeBg4C5vqHrKdqFmOL7gXlaupROT5MA'
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
   baseURL: 'https://proxy.dap.rocks/ganapp.dap.rocks/api/',
  // timeout: 1000,
   headers: {'X-Authorization': `Bearer ${token}`}
})

Vue.prototype.$http = axiosIns

export default axiosIns
